import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          {/* <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Sanjay A </span>
            from <span className="purple"> Coimbatore.</span>
            <br />
            I am currently pursuing my Bachelor's in Engineering in <span className="purple">Computer and Communication</span> at Sri Eshwar College of Engineering
            <br />
            I have completed Diplomo in <span className="purple">Instrumentaion and Control Engineering</span> at Nachimuthu Polytechnic College
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul> */}

          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
